import { Config } from '@/config';
import { ApiService } from '@/services/api.service';
import { getDaysBeforeClosing, SHORT_DATE_FORMAT, toMoment } from '@/util/date-util';

class TenantsService {
  getTenants() {
    // activeOnly now defaults to true on the API; the admin tenants screen needs
    // inactive tenants too (status filter + activate/deactivate toggle).
    return ApiService.get(`${Config.api.auth.url}tenants`, { params: { activeOnly: false } }).then((response) => {
      return mapTenants(response.data);
    });
  }

  getTenantById(tenantId) {
    return ApiService.get(`${Config.api.auth.url}tenants/${tenantId}`).then((response) => {
      return mapToTenant(response.data);
    });
  }

  createTenant(tenant) {
    return ApiService.post(`${Config.api.auth.url}tenants`, tenant).then((response) => response.data);
  }

  updateTenant({ tenantId, tenant }) {
    return ApiService.patch(`${Config.api.auth.url}tenants/${tenantId}`, tenant).then((response) =>
      mapToTenant(response.data),
    );
  }
}

const mapTenants = (results = []) =>
  results.map((t) => ({
    id: t.id,
    name: t.name,
    description: t.description || '-',
    subscriptionType: t.subscriptionType.toLowerCase(),
    trialStartDate: t.trialStartDate ? toMoment(t.trialStartDate).format(SHORT_DATE_FORMAT) : '-',
    trialEndDate: t.trialEndDate ? toMoment(t.trialEndDate).format(SHORT_DATE_FORMAT) : '-',
    active: t.active,
    daysBeforeTrialEnds: t.trialStartDate && t.trialEndDate ? getDaysBeforeClosing(t.trialEndDate) : null,
    users: Array.isArray(t.users) ? t.users : undefined,
  }));

const mapToTenant = ({
  id,
  name,
  description,
  subscriptionType,
  trialStartDate,
  trialEndDate,
  trialOn,
  active,
  users,
}) => ({
  id: id,
  name: name,
  description: description || '-',
  subscriptionType: subscriptionType.toLowerCase(),
  trialStartDate: trialStartDate ? toMoment(trialStartDate).format(SHORT_DATE_FORMAT) : '-',
  trialEndDate: trialEndDate ? toMoment(trialEndDate).format(SHORT_DATE_FORMAT) : '-',
  trialOn: trialOn,
  active: active,
  daysBeforeTrialEnds: trialStartDate && trialEndDate ? getDaysBeforeClosing(trialEndDate) : null,
  users: users,
});

export const tenantsService = new TenantsService();
